import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Fill, Stroke, Style } from 'ol/style';

import Circle from 'ol/geom/Circle';
import { ConfirmationDialogComponent } from '../tools/capture-tool/confirmation-dialog/confirmation-dialog.component';
import Feature from 'ol/Feature';
import { FeatureNameComponent } from '../tools/feature-name/feature-name.component';
import { FeaturesListComponent } from '../tools/features-list/features-list.component';
import { ForwardBackwardToolServiceService } from '../../services/forward_backward/forward-backward-tool-service.service';
import { GlobalService } from 'src/app/services/global.service';
import { HttpClient } from '@angular/common/http';
import { LiveShareExpiredModalComponent } from 'src/app/modules/shared/components/modals/live-share-expired-modal/live-share-expired-modal.component';
import { LiveShareExpiredModalCustomComponent } from 'src/app/modules/shared/components/modals/live-share-expired-modal-custom/live-share-expired-modal-custom.component';
import { LiveShareExpiredModalFdpComponent } from 'src/app/modules/shared/components/modals/live-share-expired-modal-fdp/live-share-expired-modal-fdp.component';
import { LiveShareExpiredModalWvComponent } from 'src/app/modules/shared/components/modals/live-share-expired-modal-wv/live-share-expired-modal-wv.component';
import { LiveShareModalComponent } from 'src/app/modules/shared/components/modals/live-share-modal/live-share-modal.component';
import Map from 'ol/Map';
import { MapServiceService } from '../../services/Map-service/map-service.service';
import { MatDialog } from '@angular/material/dialog';
import { Point } from 'ol/geom';
import Pusher from 'pusher-js';
import { ScaleLineService } from '../../services/Scale-Line/scale-line.service';
import { SideNavService } from '../../services/sidenav/side-nav.service';
import VectorImageLayer from 'ol/layer/VectorImage';
import { Vector as VectorLayer } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import View from 'ol/View';
import WKT from 'ol/format/WKT';
import { Wind } from './wind-layer';
import Zoom from 'ol/control/Zoom';
import { addLayerData } from './lightining-layer';
import { fromCircle } from 'ol/geom/Polygon';
import { fromLonLat } from 'ol/proj';
import { getBasemapData } from './base_Map';
import { wmsLayer } from './wms_layers';
import { DynamicModalEmbedToolComponent } from '../../modals/dynamic-modal-embed-tool/dynamic-modal-embed-tool.component';
import { ShareLinkService } from '../../services/Share-Link/share-link.service';
import * as CryptoJS from 'crypto-js';
import { AnnotationComponent } from '../tools/annotation/annotation.component';
import { ActivatedRoute } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
})
export class MapComponent implements OnInit, AfterViewInit {
  selected: any = null;
  toggleActive = false;
  featureExist = false;
  ctrlPress: any;
  featureFromClick: any;
  isGeoLock: any;
  ctrlRes: any;
  map: any;
  km: any;
  ft: any;
  kmPx: any;
  ftPx: any;
  radius: any;
  validate: any = [];
  shareIds: any = [];
  view!: View;
  finalResult: any;
  selFeature: any;
  attribution: any;
  baseMap_title: any;
  overlayLayer: Array<any> = [];
  layersData: Array<any> = [];
  resultsWind: Array<any> = [];
  visibility: any;
  parcelIds: Array<any> = [];
  channel: Array<any> = [];
  staticLayers: Array<any> = [];
  pusher: Array<any> = [];
  outerBuffer: any;
  extentData: any;
  lightDataSocket: any = {};
  subscribedChannels: Array<any> = [];
  baseMaps: any;
  pusher_api = { token: '619a969ab52e59405a17', option: { cluster: 'mt1' } };
  mapsData: any;
  data: any;
  dataFinal: any;
  dataFeature: any;
  zoomend: any;
  lightningGeom: any;
  isGeolockShare = false;
  lightningPoint: any;
  aniVal: any;
  basemap_data: any;
  baseMap_layers: any;
  currZoom: any;
  newZoom: any;
  matricsType: any;
  base_Map: any;
  mapName: any;
  showPanel = false;
  //for hovering
  hoverToolName: any;
  vectorLayerForBuufer: any;
  mapId: any;
  zoom: any;
  layersIds: any;
  layersId: Array<any> = [];
  allFeaturesResult: Array<any> = [];
  parcelLength = '1';
  slectedUnion = '1';
  polygonAnnotation = 'false';
  linesAnnotation = 'false';
  pointSAnnotation = 'false';
  mapResolution = '152.87405654907226';
  selectedFeatures: any;
  parcel: any;
  hideHeader = false;
  featureLayerId: any;
  selectedFeature = 'None';
  legendToolName: any;
  interActionEnable: any;
  shareData: any;
  extent: any;
  val: any;
  singleData: any;
  default_view: any;
  currentZoom: any;
  testData: any;
  KeyPressing: any;
  ctrlData: any;
  uniqFeatureData: any;
  featuresList: any = [];
  featureId: any;
  annotationId: any;
  save: any;
  rightToolName: any;
  selectedAnnotation: any;
  layerid: any;
  mapLayers: any;
  leftState: any;
  tools: any;
  defaultZoomLevel = true;
  resData: any;
  HideForEmbed = 'false';
  showLegend = false;
  mapAcl: any;
  geoLockTool = false;
  extentTap: any;
  keyMes = 'MapId';
  encrypted: any;
  innerBufferArray: any =[]
  parcelData: any = []
  sourceBuffer: any
  //dynamic modal dummy data
  dynamicModal: any = {
    html: "<h1 style='color:blue;'>Dynamic Modal Dummy Data</h1>",
    time: '1000',
    show: true,
  };
  feature: any
  feature1: any
  constructor(
    public mapService: MapServiceService,
    private SideNavService: SideNavService,
    public shareLinkService: ShareLinkService,
    private forwardBackwardService: ForwardBackwardToolServiceService,
    private dialog: MatDialog,
    private global: GlobalService,
    private http: HttpClient,
    public sacleLine: ScaleLineService,
    private route: ActivatedRoute,
    public location: PlatformLocation,
    public auth: AuthService
  ) {
    //
  }
  ngOnInit(): void {
    //check for hiding right panel in image
    this.HideForEmbed = this.mapService.embed;
    if (this.HideForEmbed == 'true') {
      history.pushState(null, null!, window.location.href);
      this.location.onPopState(() => {
        history.pushState(null, null!, window.location.href);
      });
    }
    this.mapService.hideHeader.subscribe((res: any) => {
      this.hideHeader = res;
    });
    this.mapService.isGeolock.subscribe((res: any) => {
      this.geoLockTool = res;
    });
    this.route.queryParamMap.subscribe((params) => {
      setTimeout(() => {
        this.shareLinkService.shareUrlId = params.get('share');
      }, 1000);
    });
    this.SideNavService.hideRightPanelForImage = false;
    this.mapService.event = 'Enter';
    const id = this.mapService.mapData.map_data.map_data.id.toString();
    this.encrypted = CryptoJS.AES.encrypt(id.toString(), this.keyMes);
    localStorage.setItem('mapId', this.encrypted);
    this.SideNavService.leftSideNav.subscribe((res: any) => {
      this.leftState = res;
    });
    this.SideNavService.ctrlCheck.subscribe((res1: any) => {
      this.ctrlPress = res1;
      this.mapService.ctrlPress = this.ctrlPress;
    });
    this.mapService.ParcelData = [];
    this.testData = this.mapService.mapData;
    this.mapLayers = this.mapService.mapData.map_data.map_data.layers;
    this.mapsData = this.mapService.mapData.map_data.map_data;
    this.tools = this.mapService.mapData.map_data.map_data.tools;
    this.mapService.mapsData = this.mapService.mapData.map_data.map_data;
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
    this.mapService.mapId =
      this.mapService.mapData.map_data.map_data.id.toString();
    this.mapService.shareData = this.mapService.mapData.map_data.share;
    this.mapService.default_view =
      this.mapService.mapData.map_data.default_view;

    if (
      this.tools.left_panel &&
      this.mapService.mapData.map_data.share.live_share == false
    ) {
      this.showLegend = true;
    } else if (
      this.tools.left_panel &&
      this.mapService.mapData.map_data.share.show_legend == true
    ) {
      this.showLegend = true;
    } else if (
      this.tools.left_panel == false &&
      this.mapService.mapData.map_data.share.live_share == false
    ) {
      this.showLegend = true;
    } else if (
      this.tools.left_panel == false &&
      this.mapService.mapData.map_data.share.live_share == true
    ) {
      this.showLegend = true;
    }
    // <======================Get Current Loaded Map Name==========================>
    this.baseMaps = this.mapsData.basemaps;
    if (!this.SideNavService.currentLoadedMap) {
      for (let i = 0; i < this.baseMaps.length; i++) {
        if (
          this.baseMaps[i].status == 'default' ||
          this.baseMaps[i].title == this.mapService.shareData.base_layer
        ) {
          this.SideNavService.currentLoadedMap = this.baseMaps[i].name;
          this.mapService.baseLayerName = this.baseMaps[i].name;
          this.mapService.currentMapLoad = this.baseMaps[i].title;
          this.mapService.shareCurrentMap = this.baseMaps[i].title;
        }
      }
    }

    this.mapService.mapData.map_data.map_data.layers = this.mapsData.layers;
    // testing purpose
    if (!this.mapService.shareLinkData) {
      for (let i = this.mapsData.layers.length - 1; i >= 0; i--) {
        let li = null;
        const ld = this.mapsData.layers[i];
        switch (ld.map.format) {
          case 'WMS':
            li = wmsLayer(
              ld,
              this.mapService.baseLayerName,
              i,
              this.auth.user ? this.auth.user.user.id : 0
            );
            break;
          case 'WIND':
            li = wmsLayer(
              ld,
              this.mapService.baseLayerName,
              i,
              this.auth.user ? this.auth.user.user.id : 0
            );
            break;
          default:
            continue;
        }
        li.setProperties({ mapport: ld, heading: ld['heading'] });
        li.setProperties({ title: ld.name });

        this.mapService.layersData.push(li);
      }
    }
    this.mapService.data = getBasemapData(
      this.baseMaps,
      this.mapsData,
      this.mapService
    );

    // <======================Set Defalut View==========================>
    this.setDefaultView();
    // <======================Map View And Share Data View==========================>
    if (
      this.mapService.shareData.live_share &&
      !this.mapService.shareData.expire
    ) {
      this.view = new View({
        minZoom: this.mapService.mapsData.minzoom,
        maxZoom: this.mapService.mapsData.maxzoom,
        smoothResolutionConstraint: false,
        constrainResolution: true,
        extent: this.mapService.mapsData.bounds,
        center: this.mapsData.initial_bounds,
        constrainOnlyCenter: true,
        zoom:
          this.mapService.mapsData.minzoom + +this.mapService.shareData.zoom,
      });
    } else if (this.mapService.default_view.default_set) {
      this.view = new View({
        minZoom: this.mapService.mapsData.minzoom,
        maxZoom: this.mapService.mapsData.maxzoom,
        smoothResolutionConstraint: false,
        constrainResolution: true,
        extent: this.mapService.mapsData.bounds,
        center: this.mapsData.initial_bounds,
        constrainOnlyCenter: true,
      });
    } else {
      this.view = new View({
        minZoom: this.mapService.mapsData.minzoom,
        maxZoom: this.mapService.mapsData.maxzoom,
        // zoom: this.mapService.mapsData.capzoom,
        smoothResolutionConstraint: false,
        constrainResolution: true,
        extent: this.mapsData.initial_bounds,
        center: this.mapsData.bounds,
        constrainOnlyCenter: true,
      });
    }
    // <======================Live Share Buffer==========================>
    this.liveShareShowBuffer();
    // <======================Intail Map==========================>
    this.mapService.mapLayer = new Map({
      pixelRatio: 1,
      layers: [...this.mapService.data],
      target: 'map',
      view: this.view,
    });
    // <======================Set All Share Data==========================>
    this.setAllShareMap();

    // <======================set view For shares and Map==========================>
    if (this.mapService.isLiveShareLink === 'true' && !this.isGeolockShare) {
      this.mapService.mapLayer
        .getView()
        .fit(this.extentTap, { constrainResolution: false });
      this.mapService.mapLayer
        .getView()
        .setZoom(
          this.mapService.mapsData.minzoom + +this.mapService.shareData.zoom
        );
      setTimeout(() => {
        this.mapService.mapLayer.updateSize();
      });
    } else if (this.mapService.checkDefualtView) {
      this.mapService.mapLayer
        .getView()
        .fit(this.extentTap, { constrainResolution: false });
      this.mapService.mapLayer
        .getView()
        .setZoom(
          this.mapService.mapsData.minzoom + +this.mapService.default_view.zoom
        );
      setTimeout(() => {
        this.mapService.mapLayer.updateSize();
      });
    } else if (this.isGeolockShare) {
      this.mapService.mapLayer
        .getView()
        .fit(this.mapsData.bounds, { constrainResolution: false });
      this.mapService.mapLayer
        .getView()
        .setZoom(
          this.mapService.mapsData.minzoom + +this.mapService.shareData.zoom
        );
      setTimeout(() => {
        this.mapService.mapLayer.updateSize();
      });
    } else {
      this.mapService.mapLayer
        .getView()
        .fit(this.mapsData.initial_bounds, this.mapService.mapLayer.getSize(), {
          constrainResolution: false,
        });
      setTimeout(() => {
        this.mapService.mapLayer.updateSize();
      });
    }
    // End
    // <======================Add Layer into Map==========================>
    this.addLayer();
    this.currZoom = this.mapService.mapLayer.getView().getZoom();
    // <======================Moveend==========================>
    this.mapService.mapLayer.on('moveend', () => {
      this.layersIds = this.mapService.getLayersId();
      this.mapService.bufferIds = this.mapService.getLayersId();
      if (!this.forwardBackwardService.moving) {
        this.forwardBackwardService.pushData();
      }

      this.forwardBackwardService.moving = false;
      if (!this.mapService.movendWork) {
        if (this.currZoom === 20) {
          this.mapService.mapLayer
            .getView()
            .setResolution(
              this.mapService.mapLayer.getView().getResolution() * 0.5
            );

          this.newZoom = this.mapService.mapLayer.getView().getZoom();
          this.mapService.currentMapZoom = this.mapService.mapLayer
            .getView()
            .getZoom();
          this.sacleLine.scaleLine(this.newZoom);
          this.mapService.setCurrentZoom(this.newZoom);
        } else {
          this.newZoom = this.mapService.mapLayer.getView().getZoom();
          this.mapService.currentMapZoom = this.mapService.mapLayer
            .getView()
            .getZoom();
          this.sacleLine.scaleLine(this.newZoom);
          this.mapService.setCurrentZoom(this.newZoom);
        }
      } else {
        this.newZoom = this.mapService.mapLayer.getView().getZoom();
        this.mapService.currentMapZoom = this.mapService.mapLayer
          .getView()
          .getZoom();
        this.sacleLine.scaleLine(this.newZoom);
        this.mapService.setCurrentZoom(this.newZoom);
      }
    });
    this.mapService.currZoom = this.currZoom;
    // <======================Set Galobal Layer==========================>
    this.mapService.listResult = new VectorSource();
    this.mapService.result = new VectorImageLayer({
      source: this.mapService.listResult,
      zIndex: 100,
      renderBuffer: 1e10,
    });
    this.mapService.mapLayer.addLayer(this.mapService.result);
    if (this.mapService.shareData.buffers_inner_list) {
      this.mapService.mapLayer.addLayer(this.vectorLayerForBuufer);
    }
    // <======================Get Active Layer Ids==========================>
    this.layersIds = this.mapService.getLayersId();
    this.mapService.captureFeature.subscribe((res: any) => {
      this.val = res;
    });
    this.forwardBackwardService.history(this.mapService.mapLayer);
    this.mapService.toolName.subscribe((res) => {
      this.legendToolName = res;
      this.SideNavService.getToolName = this.legendToolName;
    });
    this.SideNavService.isLoadedFeatureList.subscribe((res: any) => {
      this.rightToolName = res;
    });

    this.SideNavService.RightToolName.subscribe((res) => {
      this.hoverToolName = res;
    });

    this.mapService.drawInteraction.subscribe((res) => {
      this.interActionEnable = res;
    });
    // <======================Set Map On Click Function==========================>
    this.mapService.mapLayer.on('click', (evt: any) => {
      this.SideNavService.setFeatureNameView = true;
      this.mapService.searchResult = false;
      if (
        !this.mapService.selectLayer &&
        this.val &&
        this.legendToolName === 'Capture'
      ) {
        this.dialog.open(ConfirmationDialogComponent, {
          disableClose: true,
        });
        this.SideNavService.closeRightSideNav();
        if (this.mapService.result) {
          this.mapService.result.getSource().clear();
          this.SideNavService.saveFeatureListData = [];
        }
      } else {
        if (
          (this.legendToolName === 'Metrics' ||
            this.legendToolName === 'Zoom Box') &&
          this.interActionEnable === true
        ) {
          return;
        } else if (this.interActionEnable === true) {
          return;
        } else {
          const feature: any = this.mapService.mapLayer.forEachFeatureAtPixel(
            evt.pixel,
            function (feature: any) {
              return feature;
            }
          );
          this.featureFromClick = feature;
          if(this.legendToolName === 'DEM Downloader') {
            this.mapService.getdrawFeature(feature.get('number'))
            return;
          }
          //to destroy preselected annotation when single click
          if (!this.ctrlPress) {
            this.mapService.preSelectedAnnotation = '';
          }

          if (
            feature &&
            feature.get('type') == 'point' &&
            feature.get('fromTool') === 'annotation' &&
            !this.mapService.preSelectedAnnotation &&
            !this.ctrlPress
          ) {
            this.SideNavService.setFeatureNameView = true;
            this.SideNavService.setOpenZoom({
              id: feature.get('id'),
              data: feature.get('data'),
              type: feature.get('type'),
            });
            return;
          }
          if (feature && this.ctrlPress) {
            this.mapService.featureId = feature.get('number');
          }

          if (
            feature &&
            feature.get('type') == 'point' &&
            feature.get('fromTool') === 'annotation' &&
            !this.mapService.preSelectedAnnotation &&
            !this.ctrlPress
          ) {
            this.SideNavService.setFeatureNameView = true;
            this.SideNavService.setOpenZoom({
              id: feature.get('id'),
              data: feature.get('data'),
              type: feature.get('type'),
            });
            return;
          } else if (
            feature &&
            feature.get('type') === 'line' &&
            feature.get('fromTool') === 'annotation' &&
            !this.mapService.preSelectedAnnotation &&
            !this.ctrlPress
          ) {
            this.SideNavService.setFeatureNameView = true;
            this.SideNavService.setOpenZoom({
              id: feature.get('id'),
              data: feature.get('data'),
              type: feature.get('type'),
            });
            return;
          } else if (
            feature &&
            feature.get('type') === 'polygon' &&
            feature.get('fromTool') === 'annotation' &&
            !this.mapService.preSelectedAnnotation &&
            !this.ctrlPress
          ) {
            this.SideNavService.setFeatureNameView = true;
            this.SideNavService.setOpenZoom({
              id: feature.get('id'),
              data: feature.get('data'),
              type: feature.get('type'),
            });
            return;
          } else if (
            feature &&
            feature.get('type') === 'geomcollection' &&
            feature.get('fromTool') === 'annotation' &&
            !this.mapService.preSelectedAnnotation &&
            !this.ctrlPress
          ) {
            this.SideNavService.setFeatureNameView = true;
            this.SideNavService.setOpenZoom({
              id: feature.get('id'),
              data: feature.get('data'),
              type: feature.get('type'),
            });
            return;
          } else if (
            feature &&
            feature.get('type1') === 'geomcollection' &&
            feature.get('fromTool') === 'annotation' &&
            feature.get('subType') === 'folder' &&
            !this.mapService.preSelectedAnnotation &&
            !this.ctrlPress
          ) {
            this.SideNavService.setFeatureNameView = true;
            this.SideNavService.setOpenZoom({
              id: feature.get('id'),
              data: feature.get('data'),
              type: feature.get('type1'),
              folderId: feature.get('folderId'),
            });
            return;
          } else if (
            feature &&
            feature.get('type1') === 'polygon' &&
            feature.get('fromTool') === 'annotation' &&
            feature.get('subType') === 'folder' &&
            !this.mapService.preSelectedAnnotation &&
            !this.ctrlPress
          ) {
            this.SideNavService.setFeatureNameView = true;
            this.SideNavService.setOpenZoom({
              id: feature.get('id'),
              data: feature.get('data'),
              type: feature.get('type1'),
              folderId: feature.get('folderId'),
            });
            return;
          } else if (
            feature &&
            feature.get('type1') === 'point' &&
            feature.get('fromTool') === 'annotation' &&
            feature.get('subType') === 'folder' &&
            !this.mapService.preSelectedAnnotation &&
            !this.ctrlPress
          ) {
            this.SideNavService.setFeatureNameView = true;
            this.SideNavService.setOpenZoom({
              id: feature.get('id'),
              data: feature.get('data'),
              type: feature.get('type1'),
              folderId: feature.get('folderId'),
            });
            return;
          } else if (
            feature &&
            feature.get('type1') === 'line' &&
            feature.get('fromTool') === 'annotation' &&
            feature.get('subType') === 'folder' &&
            !this.mapService.preSelectedAnnotation &&
            !this.ctrlPress
          ) {
            this.SideNavService.setFeatureNameView = true;
            this.SideNavService.setOpenZoom({
              id: feature.get('id'),
              data: feature.get('data'),
              type: feature.get('type1'),
              folderId: feature.get('folderId'),
            });
            return;
          } else {
            this.SideNavService.setFeatureNameView = true;
            this.SideNavService.type = '';
            this.overlayLayer = this.mapService.getLayersId();
            for (let i = 0; i <= this.mapLayers.length; i++) {
              for (let j = 0; j <= this.overlayLayer.length; j++) {
                if (
                  (this.overlayLayer[j] == this.mapLayers[i]?.id &&
                    this.mapLayers[i]?.name === 'Parcels') ||
                  this.mapLayers[i]?.name === 'PLSS'
                ) {
                  this.radius =
                    0.01 * this.mapService.mapLayer.getView().getResolution();
                } else {
                  this.radius =
                    8.0 * this.mapService.mapLayer.getView().getResolution();
                }
              }
            }
            const data = evt.coordinate;
            const pointData = new Point(data);
            const coordinates = pointData.getCoordinates();
            const wkt = new WKT();
            this.mapService.pointGeometry = wkt.writeGeometry(pointData);
            this.mapService.setPointGeometry(wkt.writeGeometry(pointData));
            const circleGeometry = new Circle(coordinates, this.radius);
            const polygonFromCircleGeometry = fromCircle(circleGeometry);

            this.mapService.polygonGeometry = wkt.writeGeometry(
              polygonFromCircleGeometry
            );
            this.mapService.setPolygonGeometry(
              wkt.writeGeometry(polygonFromCircleGeometry)
            );
            this.getAdvanceSelect();
          }
        }
      }
    });
    // Disable Controls
    this.disableMapZoomControl();
    // Set Data For Wind Layer
    this.setDataForWindLayer();
    //hover on open layer
    this.mouseOut();
    //Pointer Move on MAp
    this.pointerMove();
    //Zoom controls
    this.sacleLine.zoomIn();
    this.sacleLine.zoomOut();
    this.mapService.animate.subscribe((res: any) => {
      if (res) {
        this.aniVal = res;
      }
    });
    //dynamic modal handling
    this.mapService.dynamicModalCheck(
      this.mapService.mapId,
      this.mapService.isLiveShareLink,
      true,
      true,
      this.mapService.mapData.map_data.share.is_print
    );
    //Lightning Layers
    this.setLightningLayerData();
    //Activity Loging
    // <======================Set Layer Order==========================>
    this.mapsData.layers.sort((a: any, b: any) => {
      return a.show_order - b.show_order;
    });
    //save sorted layers in service

    //check moved from top to bottom for selected annotation in shared link
    if (
      this.mapService.mapData.map_data.share.live_share == true &&
      this.mapService.mapData.map_data.share.is_print == false &&
      this.mapService.mapAccessLevel === 500 &&
      this.tools.annotator
    ) {
      this.mapService.getAnnotation(this.mapId).subscribe((res) => {
        if (res.annotation.length > 0) {
          this.SideNavService.annotationData = res.annotation;

          const annot = {
            component: AnnotationComponent,
            show: 'false',
          };
          this.SideNavService.shareAnnot = true;
          this.SideNavService.loadFirstTimeAnnot = false;
          this.SideNavService.leftMenuClicked({ data: annot });

          if (this.mapService.mapData.map_data.share.selected_point != '') {
            for (let i = 0; i < this.SideNavService.annotationData.length; i++) {
              if (
                this.SideNavService.annotationData[i].id.toString() ==
                this.mapService.mapData.map_data.share.selected_point.toString()
              ) {
                setTimeout(() => {
                  this.SideNavService.setOpenZoom({
                    id: this.SideNavService.annotationData[i].id,
                    data: this.SideNavService.annotationData[i],
                    type: this.SideNavService.annotationData[i].type,
                  });
                }, 800);
                break;
              }
            }
          }
        } else if (res.folders) {
          for (let i = 0; i < res.folders.length; i++) {
            this.SideNavService.annotationData = res.folders[i].annotation;
            const annot = {
              component: AnnotationComponent,
              show: 'false',
            };
            this.SideNavService.shareAnnot = true;
            this.SideNavService.loadFirstTimeAnnot = false;
            this.SideNavService.leftMenuClicked({ data: annot });

            if (this.mapService.mapData.map_data.share.selected_point != '') {
              for (let i = 0; i < this.SideNavService.annotationData.length; i++) {
                if (
                  this.SideNavService.annotationData[i].id.toString() ==
                  this.mapService.mapData.map_data.share.selected_point.toString()
                ) {
                  setTimeout(() => {
                    this.SideNavService.setOpenZoom({
                      id: this.SideNavService.annotationData[i].id,
                      data: this.SideNavService.annotationData[i],
                      type: this.SideNavService.annotationData[i].type,
                    });
                  }, 800);
                  break;
                }
              }
            }
          }
        }

      });
    } else if (
      this.mapService.mapData.map_data.share.live_share == true &&
      this.mapService.mapData.map_data.share.is_print == true
    ) {
      this.mapService.getAnnotation(this.mapId).subscribe((res) => {
        if (res.annotation.length > 0) {
          this.SideNavService.annotationData = res.annotation;
          const annot = {
            component: AnnotationComponent,
            show: 'false',
          };
          this.SideNavService.shareAnnot = true;
          this.SideNavService.loadFirstTimeAnnot = false;
          this.SideNavService.leftMenuClicked({ data: annot });
          for (let i = 0; i < this.SideNavService.annotationData.length; i++) {
            if (
              this.SideNavService.annotationData[i].id.toString() ==
              this.mapService.mapData.map_data.share.selected_point.toString()
            ) {
              setTimeout(() => {
                this.SideNavService.setOpenZoom({
                  id: this.SideNavService.annotationData[i].id,
                  data: this.SideNavService.annotationData[i],
                  type: this.SideNavService.annotationData[i].type,
                });
                setTimeout(() => {
                  const id = document.getElementById(
                    'containerRefID'
                  ) as HTMLElement;
                  id.setAttribute('id', 'imageReady');
                }, 800);
              }, 1100);
              break;
            }
          }
        } else if (res.folders) {
          for (let i = 0; i < res.folders.length; i++) {
            this.SideNavService.annotationData = res.folders[i].annotation;
            const annot = {
              component: AnnotationComponent,
              show: 'false',
            };
            this.SideNavService.shareAnnot = true;
            this.SideNavService.loadFirstTimeAnnot = false;
            this.SideNavService.leftMenuClicked({ data: annot });
            for (let i = 0; i < this.SideNavService.annotationData.length; i++) {
              if (
                this.SideNavService.annotationData[i].id.toString() ==
                this.mapService.mapData.map_data.share.selected_point.toString()
              ) {
                setTimeout(() => {
                  this.SideNavService.setOpenZoom({
                    id: this.SideNavService.annotationData[i].id,
                    data: this.SideNavService.annotationData[i],
                    type: this.SideNavService.annotationData[i].type,
                  });
                  setTimeout(() => {
                    const id = document.getElementById(
                      'containerRefID'
                    ) as HTMLElement;
                    id.setAttribute('id', 'imageReady');
                  }, 800);
                }, 1100);
                break;
              }
            }
          }

        }
      });
    }
    //for adding selector for pypupeteer
    setTimeout(() => {
      const id = document.getElementById('containerRefID') as HTMLElement;
      id.setAttribute('id', 'imageReady');
    }, 800);

    // this.http.get('../../../../../assets/json/gfs.json').subscribe(data => {
    //   debugger
    //   this.resultsWind.push(data);
    //   console.log('this.resultsWind', this.resultsWind)
    // });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.mapService.mapLayer.updateSize();
    }, 50);
  }

  addLayer() {
    const length = this.mapService.layersData.length;
    for (let i = 0; i < length; i++) {
      this.mapService.mapLayer.addLayer(this.mapService.layersData[i]);
    }
  }
  uniqByKeepFirst(a: any, key: any) {
    const seen = new Set();
    return a.filter((item: any) => {
      const k = key(item);
      return seen.has(k) ? false : seen.add(k);
    });
  }
  pointerMove() {
    this.mapService.mapLayer.on('pointermove', (e: any, self = this) => {
      if (this.mapService.stopHover) {
        this.SideNavService.newAnnoCreated = false;
        if (this.rightToolName == 'Feature') {
          this.save = this.SideNavService.saveFeatureListData;

          self.selected = null;

          self.mapService.mapLayer.forEachFeatureAtPixel(
            e.pixel,

            function (feature: any) {
              self.selected = feature;
              if (self.selected) {
                if (self.selected.get('dataObject')) {
                  self.SideNavService.setFeatureNameView = true;
                  self.mapService.searchResult = false;
                  self.SideNavService.clearFeatureList = true;
                  self.SideNavService.rightMenuClicked({
                    component: FeatureNameComponent,
                    data: self.selected.get('dataObject'),
                    history: false,
                    push: false,
                  });
                }
              }
              return true;
            }
          );
          if (
            self.save &&
            !self.selected &&
            this.hoverToolName !== 'FeatureList'
          ) {
            self.SideNavService.setFeatureNameView = false;
            self.mapService.searchResult = false;
            self.SideNavService.rightMenuClicked({
              component: FeaturesListComponent,
              data: self.save,
              history: false,
              push: false,
            });

            self.SideNavService.saveFeatureListData = self.save;
          }
        }
      }
    });
  }
  disableMapZoomControl() {
    this.mapService.mapLayer.getControls().forEach((control: any) => {
      if (control instanceof Zoom) {
        this.mapService.mapLayer.removeControl(control);
      }
    }, this);
  }
  setDataForWindLayer() {
    //check updated for multiple wind layers to load file one time on start
    for (const id in this.mapsData.layers) {
      if (
        this.mapsData.layers[id].map.format == 'wind' &&
        this.mapsData.layer[id].map.visible == true
      ) {
        Wind({ map: this.mapService.mapLayer }, this.mapsData.layers[id].name);
        break;
      }
    }
  }
  mouseOut() {
    const element = document.getElementById('map') as HTMLElement;
    element.addEventListener('mouseout', () => {
      this.hideWindInfo();
      this.save = this.SideNavService.saveFeatureListData;
      if (
        this.save &&
        this.save.length != 0 &&
        this.hoverToolName === 'FeatureName'
      ) {
        this.SideNavService.setFeatureNameView = false;
        this.SideNavService.rightMenuClicked({
          component: FeaturesListComponent,
          data: this.save,
          history: false,
          push: false,
        });

        this.SideNavService.saveFeatureListData = this.save;
      }
    });
  }
  getAdvanceSelect() {
    //check for hidding data panel and then show
    if (this.SideNavService.hideRightPanelForImage) {
      this.SideNavService.closeRightSideNav();
      this.SideNavService.hideRightPanelForImage = false;
    }
    this.SideNavService.fromAnnotation = false;
    this.SideNavService.fromAnnotationFeature = false;
    if (this.SideNavService.getToolName === 'Capture') {
      this.layersIds = '3620,3621,3622,3623,3713';
    } else {
      this.layersIds;
    }
    if (!this.ctrlPress) {
      this.mapService.perviousLabel = '0';
    }

    this.global.toggleLoader(true);
    this.mapService.stopHover = true;
    this.activityAdvanceSelect();
    this.annotationId =
      this.featureFromClick && this.featureFromClick.get('id');
    if (!this.annotationId) {
      this.annotationId = '';
    }
    this.mapService
      .getSearchCoordinates(
        this.mapId,
        this.mapService.getLayersId(),
        this.mapService.polygonGeometry,
        this.mapService.pointGeometry,
        this.parcelLength,
        this.slectedUnion,
        this.mapService.ctrlCheck.toString(),
        this.polygonAnnotation,
        this.linesAnnotation,
        this.pointSAnnotation,
        this.mapService.mapLayer.getView().getResolution().toString(),
        this.selectedFeature,
        this.mapService.preSelectedAnnotation,
        '',
        this.mapService.currentMapZoom
      )
      .subscribe((res) => {
        this.mapService.selectedBufferData = [];
        this.mapService.allBuffersFeatures = [];
        if (res.features.length) {
          this.mapService.perviousLabel =
            res.features[res.features.length - 1].label.toString();
        }
        if (this.ctrlPress) {
          const dataFeature = this.mapService.ParcelData;

          this.mapService.ctrlPush = this.ctrlPress;
          this.resData = res;

          this.ctrlData = '';
          this.uniqFeatureData = '';
          this.mapService.innerBuffer = []
          this.featureExist = false;
          for (let j = 0; j < dataFeature.length; j++) {
            if (
              this.resData.features === undefined ||
              this.resData.features.length == 0
            ) {
              if (this.mapService.featureId === dataFeature[j].id) {
                dataFeature.splice(j, 1);
                this.featureExist = true;
              }
            } else if (this.resData.features[0].id === dataFeature[j].id) {
              dataFeature.splice(j, 1);
              this.featureExist = true;
            }
          }

          if (this.featureExist) {
            this.uniqFeatureData = dataFeature;
          } else {
            for (let i = 0; i < this.resData.features.length; i++) {

              if (dataFeature.length < this.SideNavService.searchLimit) {
                // this.ctrlData = this.resData.features.concat(dataFeature[i]);
                this.ctrlData = dataFeature.concat(this.resData.features[i]);
                this.uniqFeatureData = this.uniqByKeepFirst(
                  this.ctrlData,
                  (it: any) => it.id
                );
              } else {
                //prevent adding more features when limit full
                this.uniqFeatureData = dataFeature;
                break;
              }
            }
          }
          this.mapService.ParcelData = [];
          this.mapService.ParcelData = this.uniqFeatureData;
          // localStorage.removeItem('seletedFeature');
          // localStorage.setItem(
          //   'seletedFeature',
          //   JSON.stringify(this.uniqFeatureData)
          // );
          this.ctrlRes = { features: this.uniqFeatureData };
          this.selectedFeatures = this.ctrlRes.features;
          const highestLabel = this.selectedFeatures.reduce((prevObj: any, currentObj: any) => {
            return (prevObj.label > currentObj.label) ? prevObj : currentObj;
          }).label;
          this.mapService.perviousLabel = highestLabel
          const fields: any = {};
          if (this.selectedFeatures.length > 1) {
            this.mapService.parcel = '';
            this.mapService.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              this.mapService.innerBuffer.push(this.selectedFeatures[i].geom_wkt)
              if (!('is_annotation' in this.selectedFeatures[i])) {
                this.mapService.multiParcelId.push(this.selectedFeatures[i].id);

                if (fields[this.selectedFeatures[i].layer_id]) {
                  fields[this.selectedFeatures[i].layer_id.toString()].push(
                    this.selectedFeatures[i].id.toString()
                  );
                } else {
                  fields[this.selectedFeatures[i].layer_id] = [];
                  fields[this.selectedFeatures[i].layer_id.toString()].push(
                    this.selectedFeatures[i].id.toString()
                  );
                }
                this.mapService.parcel = JSON.stringify(fields);
                this.mapService.featureLayersId.push(
                  this.selectedFeatures[i].layer_id
                );
                this.mapService.featureLayerId = [
                  ...new Set(this.mapService.featureLayersId),
                ].toString();
              }
            }
          } else {
            this.mapService.parcel = '';
            this.mapService.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              if (!('is_annotation' in this.selectedFeatures[i])) {
                this.mapService.multiParcelId.push(this.selectedFeatures[i].id);
                // multiParcel
                this.mapService.multiParcel = false;
                // parcel ID
                this.mapService.parcels.push(this.selectedFeatures[i].id);
                this.mapService.parcel = [
                  ...new Set(this.mapService.parcels),
                ].toString();
                // Feature Layer Id
                this.mapService.featureLayersId.push(
                  this.selectedFeatures[i].layer_id
                );
                this.mapService.featureLayerId = [
                  ...new Set(this.mapService.featureLayersId),
                ].toString();
              }
            }
          }

          this.SideNavService.decideComponent(this.ctrlRes);
        } else {
          this.mapService.selectedParcels = [];
          this.mapService.innerBuffer = []
          this.mapService.hideRunButton = true;
          this.selectedFeatures = res.features;
          this.singleData = res;
          const fields: any = {};
          if (this.selectedFeatures.length > 1) {
            this.mapService.parcel = '';
            this.mapService.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              if (!('is_annotation' in this.selectedFeatures[i])) {
                this.mapService.multiParcelId.push(this.selectedFeatures[i].id);
                if (fields[this.selectedFeatures[i].layer_id]) {
                  fields[this.selectedFeatures[i].layer_id.toString()].push(
                    this.selectedFeatures[i].id.toString()
                  );
                } else {
                  fields[this.selectedFeatures[i].layer_id] = [];
                  fields[this.selectedFeatures[i].layer_id.toString()].push(
                    this.selectedFeatures[i].id.toString()
                  );
                }
                this.mapService.parcel = JSON.stringify(fields);
                this.mapService.featureLayersId.push(
                  this.selectedFeatures[i].layer_id
                );
                this.mapService.featureLayerId = [
                  ...new Set(this.mapService.featureLayersId),
                ].toString();
              }
            }
          } else {
            this.mapService.parcel = '';
            this.mapService.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              if (!('is_annotation' in this.selectedFeatures[i])) {
                this.mapService.multiParcelId.push(this.selectedFeatures[i].id);
                // multiParcel
                this.mapService.multiParcel = false;
                // parcel ID
                this.mapService.parcels.push(this.selectedFeatures[i].id);
                this.mapService.parcel = [
                  ...new Set(this.mapService.parcels),
                ].toString();
                // Feature Layer Id
                this.mapService.featureLayersId.push(
                  this.selectedFeatures[i].layer_id
                );
                this.mapService.featureLayerId = [
                  ...new Set(this.mapService.featureLayersId),
                ].toString();
              }
            }
          }
          this.mapService.ParcelData = [];
          this.mapService.ParcelData = res.features;
          this.SideNavService.decideComponent(this.singleData);
        }
      });
  }
  calculatezoom() {
    const zoom =
      this.mapService.mapsData.minzoom + +this.mapService.shareData.zoom;
    this.sacleLine.scaleLine(zoom);
  }
  liveShareShowBuffer() {
    this.sourceBuffer = new VectorSource();
    this.vectorLayerForBuufer = new VectorLayer({
      source: this.sourceBuffer,
    });
    this.innerBuffers()
    this.outerBuffers()
  }
  innerBuffers() {
    if (this.mapService.shareData.buffers_inner_list) {
      const innerBuffer = this.mapService.shareData.buffers_inner_list;
      const format = new WKT()
      for (let index = 0; index < innerBuffer.length; index++) {
        const element = innerBuffer[index];
        this.feature = format.readFeature(element);
          this.feature.setStyle(
            new Style({
              fill: new Fill({
                color: 'rgba(0, 255, 204, 0.3)',
              }),
              // stroke: new Stroke({
              //   color: '#00FFCB',
              //   width: 3,
              // }),
              zIndex: -1,
            })
          );
          this.sourceBuffer.addFeatures([this.feature]);
      }
    }
  }

  outerBuffers() {
    const format = new WKT();
    const outerBuffer = this.mapService.shareData.buffers_list;
    if(outerBuffer) {
      for (let j = 0; j < outerBuffer.length; j++) {
        const element = outerBuffer[j];
        this.feature1 = format.readFeature(element);
        this.feature1.setStyle(
          new Style({
            stroke: new Stroke({
              color: '#00FFCB',
              width: 3,
            }),
            zIndex: -1,
          })
        );
        this.sourceBuffer.addFeatures([this.feature1]);
      }
    }

  }
  setAllShareMap() {
    if (
      this.mapService.shareData.live_share &&
      !this.mapService.shareData.expire
    ) {
      if (this.mapService.shareData.geolock_id) {
        this.isGeolockShare = true;
        this.mapService.mapsData.bounds[0] =
          +this.mapService.shareData.xmin_bound;
        this.mapService.mapsData.bounds[1] =
          +this.mapService.shareData.xmax_bound;
        this.mapService.mapsData.bounds[2] =
          +this.mapService.shareData.ymin_bound;
        this.mapService.mapsData.bounds[3] =
          +this.mapService.shareData.ymax_bound;
      } else {
        this.extentTap = [
          +this.mapService.shareData.xmin_bound,
          +this.mapService.shareData.xmax_bound,
          +this.mapService.shareData.ymin_bound,
          +this.mapService.shareData.ymax_bound,
        ];
      }
      this.fullScreenEmbedTool(
        this.mapService.shareData.tcpd_embed,
        this.mapService.shareData.basic_mode
      );
      this.defaultZoomLevel = true;
      this.mapService.isLiveShareLink = 'true';
      this.mapService.movendWork = false;
      this.mapService.shareLinkData = true;
      this.mapService.bookMarkShowLayers = [];
      this.mapService.ChangeLayerClickToZoom = [];
      this.zoom = +this.mapService.shareData.zoom;
      const elem = JSON.parse('[' + this.mapService.shareData.overlay + ']');
      if (elem.length == 0) {
        for (let j = 0; j < this.mapsData.layers.length; j++) {
          let li = null;
          const ld = this.mapsData.layers[j];
          switch (ld.map.format) {
            case 'WMS':
              li = wmsLayer(
                ld,
                this.mapService.baseLayerName,
                j,
                this.auth.user ? this.auth.user.user.id : 0
              );
              break;
            case 'WIND':
              li = wmsLayer(
                ld,
                this.mapService.baseLayerName,
                j,
                this.auth.user ? this.auth.user.user.id : 0
              );
              break;
            default:
              continue;
          }
          const zoom =
            this.mapService.mapsData.minzoom + +this.mapService.shareData.zoom;
          if (zoom >= ld.zoomlevel) {
            li.setProperties({ mapport: ld, heading: ld['heading'] });
            li.setProperties({ title: ld.name });
            li.setProperties({ isVisible: false });
            li.setProperties({ isChecked: false });
            const temp = li.getProperties();
            temp.mapport.map.visible = false;
            li.setProperties({ mapport: temp.mapport });
            this.mapService.layersData.push(li);

            this.mapService.bookMarkShowLayers.push('Boundaries');
          }
          setTimeout(() => {
            this.mapService.setLayerHeadingForbookMark(
              this.mapService.bookMarkShowLayers
            );
            this.mapService.bookMarkShowLayers = [
              ...new Set(this.mapService.bookMarkShowLayers),
            ];
          }, 1000);
        }
        setTimeout(() => {
          this.mapService.setBaseMapOnClicktoZoom(
            this.mapService.baseLayerName
          );
        }, 1000);
      } else {
        this.mapService.bookMarkShowLayers = [];
        this.mapService.ChangeLayerClickToZoom = [];
        for (let j = 0; j < this.mapsData.layers.length; j++) {
          if (elem.includes(this.mapsData.layers[j].id)) {
            let li = null;
            const ld = this.mapsData.layers[j];
            switch (ld.map.format) {
              case 'WMS':
                li = wmsLayer(
                  ld,
                  this.mapService.baseLayerName,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              case 'WIND':
                li = wmsLayer(
                  ld,
                  this.mapService.baseLayerName,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              default:
                continue;
            }
            if (ld.name === 'Wind Demigod Only') {
              Wind(
                { map: this.mapService.mapLayer },
                this.mapsData.layers.name
              );
            }
            const zoom =
              this.mapService.mapsData.minzoom +
              +this.mapService.shareData.zoom;
            if (zoom >= ld.zoomlevel) {
              li.setProperties({ mapport: ld, heading: ld['heading'] });
              li.setProperties({ title: ld.name });
              li.setProperties({ isVisible: true });
              li.setProperties({ isChecked: true });
              const temp = li.getProperties();
              temp.mapport.map.visible = true;
              li.setProperties({ mapport: temp.mapport });
              this.mapService.layersData.push(li);

              this.mapService.bookMarkShowLayers.push(ld.legend.heading);
              this.mapService.bookMarkShowLayers = [
                ...new Set(this.mapService.bookMarkShowLayers),
              ];
            }
            setTimeout(() => {
              this.mapService.setLayerHeadingForbookMark(
                this.mapService.bookMarkShowLayers
              );
              this.mapService.bookMarkShowLayers = [
                ...new Set(this.mapService.bookMarkShowLayers),
              ];
            }, 1000);
          } else {
            let li = null;
            const ld = this.mapsData.layers[j];
            switch (ld.map.format) {
              case 'WMS':
                li = wmsLayer(
                  ld,
                  this.mapService.baseLayerName,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              case 'WIND':
                li = wmsLayer(
                  ld,
                  this.mapService.baseLayerName,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              default:
                continue;
            }
            const zoom =
              this.mapService.mapsData.minzoom +
              +this.mapService.shareData.zoom;
            if (zoom >= ld.zoomlevel) {
              li.setProperties({ mapport: ld, heading: ld['heading'] });
              li.setProperties({ title: ld.name });
              li.setProperties({ isVisible: false });
              li.setProperties({ isChecked: false });
              const temp = li.getProperties();
              temp.mapport.map.visible = false;
              li.setProperties({ mapport: temp.mapport });
              this.mapService.layersData.push(li);

              this.mapService.bookMarkShowLayers.push(ld.legend.heading);
              this.mapService.bookMarkShowLayers = [
                ...new Set(this.mapService.bookMarkShowLayers),
              ];
            }
          }
        }
        setTimeout(() => {
          this.mapService.setBaseMapOnClicktoZoom(
            this.mapService.baseLayerName
          );
        }, 1000);
      }

      this.mapService.setbookMarkZoom = true;
      this.layersIds = this.mapService.shareData.overlay;
      this.mapService.pointGeometry = this.mapService.shareData.point;
      this.mapService.polygonGeometry = this.mapService.shareData.wkt;
      if (
        this.mapService.shareData.geolock_id ||
        this.mapService.shareData.basic_mode
      ) {
        this.mapService.setGeoLockTool(true);
        this.isGeoLock = true;
      }
      if (this.mapService.shareData.is_print) {
        this.mapService.getHideHeader(true);
        this.mapService.panelSize = true;
        if (this.tools.left_panel == false) {
          this.showLegend = false;
        }
      }

      if (!this.mapService.shareId) {
        this.mapService.shareId = '';
      } else {
        this.mapService.shareId;
        // localStorage.removeItem('auth_token');
      }
      const value = localStorage.getItem('shareId');
      this.shareLinkService.liveShareId = value;
      if (value == null || value == this.mapService.shareData.share_id) {
        localStorage.setItem('shareId', this.mapService.shareData.share_id);
        const value = localStorage.getItem('shareId');
        this.shareLinkService.liveShareId = value;
      }
      this.global.toggleLoader(true);
      if (this.mapService.shareData.point || this.mapService.shareData.wkt) {
        this.mapService
          .getParcelData(
            'parcel',
            this.mapService.shareData.parcel,
            parseInt(this.mapId),
            this.mapService.shareData.point,
            this.mapService.shareData.wkt,
            'false',
            this.mapService.shareData.multiple_parcel.toString(),
            this.mapService.shareData.feature_layer,
            '',
            '',
            ''
          )

          .subscribe((res) => {
            const fields: any = {};
            this.selectedFeatures = res.features;
            if (this.selectedFeatures.length > 1) {
              this.mapService.parcel = '';
              this.mapService.parcels = [];
              for (let i = 0; i < this.selectedFeatures.length; i++) {
                if (!('is_annotation' in this.selectedFeatures[i])) {
                  this.mapService.multiParcelId.push(
                    this.selectedFeatures[i].id
                  );
                  if (fields[this.selectedFeatures[i].layer_id]) {
                    fields[this.selectedFeatures[i].layer_id.toString()].push(
                      this.selectedFeatures[i].id.toString()
                    );
                  } else {
                    fields[this.selectedFeatures[i].layer_id] = [];
                    fields[this.selectedFeatures[i].layer_id.toString()].push(
                      this.selectedFeatures[i].id.toString()
                    );
                  }
                  this.mapService.parcel = JSON.stringify(fields);
                  this.mapService.featureLayersId.push(
                    this.selectedFeatures[i].layer_id
                  );
                  this.mapService.featureLayerId = [
                    ...new Set(this.mapService.featureLayersId),
                  ].toString();
                }
              }
              if (this.mapService.shareData.parcel_label) {
                this.SideNavService.checkLabel = true;
              } else {
                this.SideNavService.checkLabel = false;
              }
              this.SideNavService.decideComponent(res);
              this.showPanel = true;

              if (this.mapService.dyamicModalREf.length > 0) {
                for (
                  let i = 0;
                  i < this.mapService.dyamicModalREf.length;
                  i++
                ) {
                  this.mapService.dyamicModalREf[i].close();
                }
              }
              if (this.mapService.shareData.data_panel_hide) {
                this.SideNavService.sideNavState('close');
                this.SideNavService.infoSideNav('closed');
                this.SideNavService.hideRightPanelForImage = true;
              } else {
                this.SideNavService.openRightSideNav();
              }
            } else {
              this.mapService.parcel = '';
              this.mapService.parcels = [];
              for (let i = 0; i < this.selectedFeatures.length; i++) {
                if (!('is_annotation' in this.selectedFeatures[i])) {
                  this.mapService.multiParcelId.push(
                    this.selectedFeatures[i].id
                  );
                  // multiParcel
                  this.mapService.multiParcel = false;
                  // parcel ID
                  this.mapService.parcels.push(this.selectedFeatures[i].id);
                  this.mapService.parcel = [
                    ...new Set(this.mapService.parcels),
                  ].toString();
                  // Feature Layer Id
                  this.mapService.featureLayersId.push(
                    this.selectedFeatures[i].layer_id
                  );
                  this.mapService.featureLayerId = [
                    ...new Set(this.mapService.featureLayersId),
                  ].toString();
                }
              }
              if (this.mapService.shareData.parcel_label) {
                this.SideNavService.checkLabel = true;
              } else {
                this.SideNavService.checkLabel = false;
              }
              this.SideNavService.decideComponent(res);
              this.showPanel = true;

              if (this.mapService.dyamicModalREf.length > 0) {
                for (
                  let i = 0;
                  i < this.mapService.dyamicModalREf.length;
                  i++
                ) {
                  this.mapService.dyamicModalREf[i].close();
                }
              }
              if (this.mapService.shareData.data_panel_hide) {
                this.SideNavService.sideNavState('close');
                this.SideNavService.infoSideNav('closed');
                this.SideNavService.hideRightPanelForImage = true;
              } else {
                this.SideNavService.openRightSideNav();
              }
            }
          });
      }

      if (
        (this.mapService.shareData.pro === 'On' &&
          this.mapService.shareData.default_modal) ||
        (this.mapService.shareData.checkbox_template &&
          this.mapService.shareData.pro === 'On' &&
          this.mapService.shareData.default_modal)
      ) {
        this.dialog.open(LiveShareModalComponent, {
          data: {
            title: this.mapService.shareData.my_pro_validate_expire_time,
            htmlCheckbox: this.mapService.shareData.checkbox_template,
          },
        });
      }
      if (this.mapService.shareData.template) {
        this.shareLinkService.dialogTemplate = this.dialog.open(
          DynamicModalEmbedToolComponent,
          {
            disableClose: true,
            data: {
              html: this.mapService.shareData.template,
              htmlCheckbox: this.mapService.shareData.checkbox_template,
            },
          }
        );
      }
      if (
        this.mapService.shareData.pro === 'Off' &&
        this.mapService.mapInterface.map_type === 'wv-map' &&
        !this.mapService.shareData.embed_id &&
        !this.mapService.shareData.geolock_id
      ) {
        this.dialog.open(LiveShareExpiredModalWvComponent, {
          data: {
            title: this.mapService.shareData.my_pro_validate_expire_time,
          },
          disableClose: true,
        });
      }
      if (
        this.mapService.shareData.pro === 'Off' &&
        this.mapService.mapInterface.map_type === 'pv-map' &&
        !this.isGeoLock
      ) {
        this.dialog.open(LiveShareExpiredModalComponent, {
          data: {
            title: this.mapService.shareData.my_pro_validate_expire_time,
          },
          disableClose: true,
        });
      }
      if (
        this.mapService.shareData.pro === 'Off' &&
        this.mapService.mapInterface.map_type === 'fdp-map' &&
        !this.isGeoLock
      ) {
        this.dialog.open(LiveShareExpiredModalFdpComponent, {
          data: {
            title: this.mapService.shareData.my_pro_validate_expire_time,
          },
          disableClose: true,
        });
      }
      if (
        this.mapService.shareData.pro === 'Off' &&
        this.mapService.mapInterface.map_type === 'custom-map' &&
        !this.isGeoLock
      ) {
        this.dialog.open(LiveShareExpiredModalCustomComponent, {
          data: {
            title: this.mapService.shareData.my_pro_validate_expire_time,
          },
          disableClose: true,
        });
      }
    }
  }
  fullScreenEmbedTool(tcpd: any, basicEmbed: any) {
    if (tcpd || basicEmbed) {
      this.shareLinkService.setFullScreenIcon(true);
    }
  }
  setDefaultView() {
    if (!this.mapService.default_view?.default_set == false) {
      this.mapService.movendWork = false;
      this.defaultZoomLevel = true;
      this.mapService.isLiveShareLink = 'false';
      this.mapService.checkDefualtView = true;
      this.mapService.shareLinkData = true;
      this.extentTap = [
        +this.mapService.default_view.xmin_bound,
        +this.mapService.default_view.xmax_bound,
        +this.mapService.default_view.ymin_bound,
        +this.mapService.default_view.ymax_bound,
      ];
      this.zoom = +this.mapService.default_view.zoom;
      const elem = JSON.parse('[' + this.mapService.default_view.overlay + ']');
      if (elem.length == 0) {
        for (let j = 0; j < this.mapsData.layers.length; j++) {
          let li = null;
          const ld = this.mapsData.layers[j];
          switch (ld.map.format) {
            case 'WMS':
              li = wmsLayer(
                ld,
                this.mapService.baseLayerName,
                j,
                this.auth.user ? this.auth.user.user.id : 0
              );
              break;
            case 'WIND':
              li = wmsLayer(
                ld,
                this.mapService.baseLayerName,
                j,
                this.auth.user ? this.auth.user.user.id : 0
              );
              break;
            default:
              continue;
          }
          const zoom =
            this.mapService.mapsData.minzoom +
            +this.mapService.default_view.zoom;
          if (zoom >= ld.zoomlevel) {
            li.setProperties({ mapport: ld, heading: ld['heading'] });
            li.setProperties({ title: ld.name });
            li.setProperties({ isVisible: false });
            li.setProperties({ isChecked: false });
            const temp = li.getProperties();
            temp.mapport.map.visible = false;
            li.setProperties({ mapport: temp.mapport });
            this.mapService.layersData.push(li);
          }
        }
      } else {
        for (let j = 0; j < this.mapsData.layers.length; j++) {
          if (elem.includes(this.mapsData.layers[j].id)) {
            let li = null;
            const ld = this.mapsData.layers[j];
            switch (ld.map.format) {
              case 'WMS':
                li = wmsLayer(
                  ld,
                  this.mapService.baseLayerName,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              case 'WIND':
                li = wmsLayer(
                  ld,
                  this.mapService.baseLayerName,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              default:
                continue;
            }
            const zoom =
              this.mapService.mapsData.minzoom +
              +this.mapService.default_view.zoom;
            if (zoom >= ld.zoomlevel) {
              li.setProperties({ mapport: ld, heading: ld['heading'] });
              li.setProperties({ title: ld.name });
              li.setProperties({ isVisible: true });
              li.setProperties({ isChecked: true });
              const temp = li.getProperties();
              temp.mapport.map.visible = true;
              li.setProperties({ mapport: temp.mapport });
              this.mapService.layersData.push(li);
            }
          } else {
            let li = null;
            const ld = this.mapsData.layers[j];
            switch (ld.map.format) {
              case 'WMS':
                li = wmsLayer(
                  ld,
                  this.mapService.baseLayerName,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              case 'WIND':
                li = wmsLayer(
                  ld,
                  this.mapService.baseLayerName,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              default:
                continue;
            }
            li.setProperties({ mapport: ld, heading: ld['heading'] });
            li.setProperties({ title: ld.name });
            this.mapService.layersData.push(li);
          }
        }
        setTimeout(() => {
          this.mapService.setBaseMapOnClicktoZoom(
            this.mapService.baseLayerName
          );
        }, 1000);
      }
      this.mapService.setbookMarkZoom = true;
      this.layersIds = this.mapService.default_view.overlay;
      this.mapService.pointGeometry = this.mapService.default_view.point;
      this.mapService.polygonGeometry = this.mapService.default_view.wkt;
      if (!this.mapService.shareId) {
        this.mapService.shareId = '';
      } else {
        this.mapService.shareId;
      }
      this.global.toggleLoader(true);
      this.mapService
        .getParcelData(
          'parcel',
          this.mapService.default_view.parcel,
          parseInt(this.mapId),
          this.mapService.default_view.point,
          this.mapService.default_view.wkt,
          'false',
          this.mapService.default_view.multiple_parcel.toString(),
          this.mapService.default_view.feature_layer,
          '',
          '',
          ''
        )
        .subscribe((res) => {
          if (res.features.length >= 1) {
            this.SideNavService.decideComponent(res);
            this.showPanel = true;
            if (this.mapService.shareData.data_panel_hide) {
              this.SideNavService.hideRightPanelForImage = true;
            } else {
              this.SideNavService.openRightSideNav();
            }
          }
        });
    }
  }
  setLightningLayerData() {
    this.mapService.mapLayer
      .getLayers()
      .getArray()
      .forEach((a: any) => {
        if (
          a.getProperties().title === this.mapService.currentMapLoad &&
          a.getProperties().type == 'baseMaps'
        ) {
          a.getVisible();
          a.setVisible(true);
          this.mapService.currentMap = a;
        }
      });
    addLayerData(
      this.mapService.mapLayer,
      this.mapService.currentMap,
      this.mapService
    );

    for (let i = 0; i <= this.mapLayers.length; i++) {
      if (
        this.mapLayers[i]?.data_channel !== null &&
        this.mapLayers[i]?.data_channel !== undefined
      ) {
        this.mapService.checkChannel.subscribe((data: any) => {
          this.visibility = data;
        });
        this.pusher[i] = new Pusher(
          this.pusher_api['token'],
          this.pusher_api['option']
        );
        const chanName = this.mapLayers[i]?.data_channel.split('-');
        this.lightDataSocket[chanName[0]] = [];
        this.channel[i] = this.pusher[i].subscribe(chanName[0]);
        this.channel[i].bind('pusher:subscription_succeeded', () => {
          this.subscribedChannels.push(chanName[0]);
        });
        this.channel[i].bind(chanName[1], (data: any) => {
          if (data.data.length > 0) {
            for (i = 0; i < data.data.length; i++) {
              this.lightDataSocket[chanName[0]].push(data.data[i]);
              const lightData = this.lightDataSocket[chanName[0]].shift();
              if (lightData && this.visibility) {
                const cords = lightData;
                this.lightningPoint = cords.geom;
                const wkt = new WKT();
                this.lightningPoint = wkt.readGeometry(cords.geom);
                this.lightningGeom = this.lightningPoint.getCoordinates();
                const geom = new Point(fromLonLat(this.lightningGeom));
                geom.transform('EPSG:3857', 'EPSG:4326');
                const feature = new Feature(geom);
                this.mapService.lightningSource.addFeature(feature);
              }
            }
          }
        });
      }
    }
    //Lightning Layers End
  }
  activityAdvanceSelect() {
    const pointJdonB = {
      advanced_select_layer: `${
        this.SideNavService.advanceSelectLayer == 'allLayers'
          ? 'All_Layers'
          : this.SideNavService.advanceSelectLayer
      }`,
    };
    switch (this.SideNavService.selectedBuffer) {
      case 'Point':
        this.activityLoging(
          'Click',
          `AdvancedSelect:Location:Select`,
          pointJdonB
        );

        break;
      case 'Buffer':
        this.activityLoging(
          'Click',
          `AdvancedSelect:Buffer:${this.SideNavService.advanceSelectLayer}`,
          ''
        );
    }
  }

  activityLoging(event: any, eventName: any, information: any) {

    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapService.ipAddress = res.ip;
        const body = {
          map_id: this.mapId.toString(),
          event: event,
          page: this.mapService.pageUrl,
          basemap: this.mapService.shareCurrentMap,
          event_name: eventName,
          ip: this.mapService.ipAddress,
          time: this.mapService.getTimeOnPage().toString(),
          point: '',
          wkt: '',
          event_information: JSON.stringify(information),
        };
        this.mapService.activityLogs(body).subscribe(
          () => {
            // console.log('a');
          },
          (error: any) => {
            if (error.status == 403) {
              location.reload();
            }
          }
        );
      });
  }

  hideWindInfo(): void {
    const windiv: any = document.getElementById('wind-info') as HTMLElement;
    if (windiv) {
      windiv.style.display = 'none';
    }
  }
  defualtExtent() {
    this.mapService.mapLayer
      .getView()
      .calculateExtent(this.mapService.mapLayer.getSize());
    this.mapService.mapLayer
      .getView()
      .setZoom(
        this.mapService.mapsData.capzoom
      );
  }
}
